import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  selectMessageValue,
  selectMessageType,
  selectMessageSubject,
  selectMessageTemplateId,
} from '../../redux/message/message.selector';
import { selectMessageTemplates } from '../../redux/message-template/message-template.selector';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Multiselect from 'multiselect-react-dropdown';
import {
  setMessage,
  setMessageType,
  setMessageSubject,
  setMessageHtml,
  setMessageTemplateId,
} from '../../redux/message/message.actions';
import {
  MessageSelectorContainer,
  MessageSelectorTemplateContainer,
  MessageTypeSelectorContainer,
  MessageSelectorTextbox,
} from './message-selector.styles';

const MessageSelector = ({
  messageValue,
  setMessage,
  messageSubject,
  messageType,
  setMessageType,
  setMessageHtml,
  setMessageSubject,
  setMessageTemplateId,
  hidden,
  messageTemplates,
  currTemplateId,
}) => {
  const handleChange = (event) => {
    setMessageType(event.target.value);
  };

  const onSelect = (selectedList, selectedItem) => {
    setMessage(selectedItem.message);
    setMessageHtml(selectedItem.html);
    setMessageSubject(selectedItem.subject);
    setMessageTemplateId(selectedItem.id);
  };

  const onRemove = () => {
    setMessage('');
    setMessageHtml('');
    setMessageSubject('');
    setMessageTemplateId('');
  };
  return (
    <MessageSelectorContainer
      style={{ visibility: hidden ? 'hidden' : 'visible' }}
    >
      <MessageTypeSelectorContainer>
        <FormControl component="fieldset">
          <FormLabel
            component="legend"
            sx={{
              color: 'black',
              fontWeight: 'bold',
              backgroundColor: '',
              '&.Mui-focused': {
                color: 'black',
              },
            }}
          >
            Type
          </FormLabel>
          <RadioGroup
            aria-label="Type"
            name="controlled-radio-buttons-group"
            value={messageType}
            onChange={handleChange}
          >
            <FormControlLabel
              value="Text"
              control={
                <Radio
                  sx={{
                    color: 'grey',
                    '&.Mui-checked': {
                      color: 'black',
                    },
                  }}
                />
              }
              label="Text"
            />
            <FormControlLabel
              value="Email"
              control={
                <Radio
                  sx={{
                    color: 'grey',
                    '&.Mui-checked': {
                      color: 'black',
                    },
                  }}
                />
              }
              label="Email"
            />
          </RadioGroup>
          {/* {currTemplateId ?
            (currTemplateId === 'd-3fbd86ee07ab4b67aae2af97fe578d35' ?
              (<p style={{ position: 'sticky', left: 0, bottom: 0, color: 'red', fontSize: '0.9rem' }}>* no dynamic data support</p>)
              : null)
            : null} */}
        </FormControl>
      </MessageTypeSelectorContainer>
      <MessageSelectorTextbox
        onChange={(value) => setMessage(value)}
        placeholder="Type your message"
        value={messageValue}
        isDisabled={messageSubject !== 'Custom Message' ? true : false}
      />
      <MessageSelectorTemplateContainer>
        {/* {messageTemplates.map((template, i) => {
          return (
            <MessageSelectorTemplate key={i}>
              <input
                type="radio"
                name="templates"
                value={template.message}
                onChange={(e) => {
                  setMessage(e.target.value);
                  setMessageSubject(template.subject);
                  setMessageHtml(template.html);
                  setMessageTemplateId(template.id);
                }}
              />
              <div>{template.subject}</div>
            </MessageSelectorTemplate>
          );
        })} */}
        <Multiselect
          isObject={true}
          options={messageTemplates} // Options to display in the dropdown
          onSelect={onSelect} // Function will trigger on select event
          onRemove={onRemove} // Function will trigger on remove event
          avoidHighlightFirstOption={true}
          closeOnSelect={true}
          // selectedValues={0}
          showArrow={true}
          keepSearchTerm={true}
          placeholder={'Please select a template'}
          // Property name to display in the dropdown options
          displayValue="subject"
          selectionLimit={1}
          hidePlaceholder={true}
          groupBy="location"
          style={{
            chips: { background: 'red', color: 'white', fontWeight: 'bold' },
            option: { fontSize: '15px' },
            searchBox: { backgroundColor: 'white' },
            groupHeading: {
              fontWeight: 'bold',
              color: 'white',
              fontSize: '20px',
              backgroundColor: 'red',
              padding: '3px',
            },
            optionContainer: {
              // To change css for option container
              height: '200px',
            },
          }}
        />
      </MessageSelectorTemplateContainer>
    </MessageSelectorContainer>
  );
};

const mapStateToProps = createStructuredSelector({
  messageValue: selectMessageValue,
  messageTemplates: selectMessageTemplates,
  messageType: selectMessageType,
  messageSubject: selectMessageSubject,
  currTemplateId: selectMessageTemplateId,
});

const mapDispatchToProps = (dispatch) => ({
  setMessage: (value) => dispatch(setMessage(value)),
  setMessageType: (value) => dispatch(setMessageType(value)),
  setMessageSubject: (value) => dispatch(setMessageSubject(value)),
  setMessageHtml: (value) => dispatch(setMessageHtml(value)),
  setMessageTemplateId: (value) => dispatch(setMessageTemplateId(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MessageSelector);
